// extracted by mini-css-extract-plugin
export var authorByLineTooltipTrigger = "bl_dF";
export var authorBylineContainer = "bl_dC";
export var authorPrefix = "bl_dD";